// @flow
import { SelectProps } from 'antd/lib/select';
import React from 'react';

import { notification } from 'antd';
import { branchSmiaSectionTransition } from '../../lib/api';
import type { SmiaSection } from '../../lib/types';
import { Select } from '../ui';


type Props = SelectProps & {
  orgUnitId?: number
};

type State = {
  options: null | SmiaSection[]
}

export default class extends React.Component<Props,State> {
  static defaultProps = {
    onlyBranches: false,
  };

  state:State = {
    options: null,
  };

  _isMounted = false;

  async fetch() {
try {
      const data = await branchSmiaSectionTransition.fetch({
            dispatcherOrgUnitId: this.props.orgUnitId,
          })
      if (this._isMounted) {
        this.setState({
            options: data ?? []
        });
      }
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message,
      });
    }
  }
  
  async componentDidUpdate(prevProps: Props) {
    if(prevProps.orgUnitId !== this.props.orgUnitId) {
      await this.fetch();
    }
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.fetch();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {options} = this.state;
    const {filter, orgUnitId, ...props} = this.props 
    return (
      <Select
        {...props}
      >
        {options?.map((section:SmiaSection) => (
          <Select.Option key={section.smiaSectionId} value={section.smiaSectionId}>
            {section.smiaSectionName}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

